<template>
    <div class="bg-wrap">
        <Banner></Banner>
        <div class="content">
            <div class="success">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/success.png" >
            </div>
            <div class="ok">
                <span>恭喜您，提交成功</span>
            </div>
            <div class="submit" @click="toCase">
                <label>好的</label>
            </div>
        </div>
    </div>

</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    export default {
        name: "JudgeScore",
        data(){
            return{

            }
        },
        components:{
            Banner
        },
        methods:{
            toCase(){
                this.$router.push("judgeCase")
            }
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
    }
    .content {
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
    }
    .content .success{
        img{
            width: 200px;
            /*height: 261px;*/
        }
    }
    .content .ok{
        margin-top: 30px;
        font-size: 20px;
    }
    .content .submit{
        width: 90%;
        background: #156098;
        margin-top: 30px;
        font-size: 14px;
        padding: 5px 0;
        border-radius: 5px;
        color: #FFF;
    }



</style>